import apiTransactionProduct from '@/api/vo/transactionProduct';

const defaultState = () => ({
	listTransactionProduct: [],
	transactionProductPagination: '',
	detailTransactionProduct: '',
	listTransactionApprove: [],
	transactionApprovePagination: '',
	listTransactionProductAdmin: [],
	transactionProductAdminPagination: '',
	responseSuccess: {},
});

const state = defaultState();

const getters = {};

const mutations = {

	setTransactionProduct(state, data) {
		state.listTransactionProduct = data.data;
		state.transactionProductPagination = data.pagination;
	},
	setDetailTransactionProduct(state, data) {
		state.detailTransactionProduct = data.data
	},
	setTransactionProductApprove(state, data) {
		state.listTransactionApprove = data.data;
		state.transactionApprovePagination = data.pagination;
	},
	setTransactionProductAdmin(state, data) {
		state.listTransactionProductAdmin = data.data;
		state.transactionProductAdminPagination = data.pagination;
	},
	setSuccessTransaction(state, data) {
		state.responseSuccess = data
	},
};

const actions = {

	getTransactionProductAll({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiTransactionProduct.getTransactionProductAll(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setTransactionProduct', data.results)
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setTransactionProduct', { data: [], pagination: {} });
				reject()
			});
		});
	},

	getTransactionProductWait({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiTransactionProduct.getTransactionProductWait(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setTransactionProduct', data.results)
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setTransactionProduct', { data: [], pagination: {} });
				reject()
			});
		});
	},

	getDetailTransactionProduct({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiTransactionProduct.getDetailTransactionProduct(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setDetailTransactionProduct', data.results)
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setDetailTransactionProduct', {});
				reject()
			});
		});
	},

	getTransactionApproveAll({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiTransactionProduct.getTransactionApproveAll(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setTransactionProductApprove', data.results)
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setTransactionProductApprove', { data: [], pagination: {} });
				reject()
			});
		});
	},

	getTransactionApproveWait({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiTransactionProduct.getTransactionApproveWait(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setTransactionProductApprove', data.results)
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setTransactionProductApprove', { data: [], pagination: {} });
				reject()
			});
		});
	},

	addTransactionProductStockist({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiTransactionProduct.addTransactionProductStockist(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					dispatch('success', data)
					commit('setSuccessTransaction', data.results)
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setSnackbar', {
					show: true,
					color: 'red darken-2',
					text: 'Terjadi kesalahan pada sistem, transaksi produk tidak dapat diproses.'
				}, { root: true });
				reject()
			});
		});
	},

	addTransactionProductMitra({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiTransactionProduct.addTransactionProductMitra(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					dispatch('success', data)
					commit('setSuccessTransaction', data.results)
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setSnackbar', {
					show: true,
					color: 'red darken-2',
					text: 'Terjadi kesalahan pada sistem, transaksi produk tidak dapat diproses.'
				}, { root: true });
				reject()
			});
		});
	},

	approveTransactionProduct({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiTransactionProduct.approveTransactionProduct(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					dispatch('success', data)
					commit('setSuccessTransaction', data.results)
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setSnackbar', {
					show: true,
					color: 'red darken-2',
					text: 'Terjadi kesalahan pada sistem, approval transaksi tidak dapat diproses.'
				}, { root: true });
				reject()
			});
		});
	},

	getTransactionAdminProductAll({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiTransactionProduct.getTransactionAdminProductAll(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setTransactionProductAdmin', data.results)
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setTransactionProductAdmin', { data: [], pagination: {} });
				reject()
			});
		});
	},

	getTransactionAdminProductWait({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiTransactionProduct.getTransactionAdminProductWait(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setTransactionProductAdmin', data.results)
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setTransactionProductAdmin', { data: [], pagination: {} });
				reject()
			});
		});
	},

	success({ commit }, data) {
		commit('setSnackbar', {
			show: true,
			color: 'green accent-4',
			text: data.message
		}, { root: true });
	},

	errorHandler({ commit }, response) {
		if (response.status !== undefined && response.status === 'unauthorized') {
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: response.msg
			}, { root: true });
		} else {
			switch (response.error_code) {
				case 'validationError':
					commit('setErrorValidation', response.results.validationMessage)
					break;
					
				case 'ERROR':
					commit('setSnackbar', {
						show: true,
						color: 'red darken-2',
						text: response.message
					}, { root: true });
					break;
						
				default:
					commit('setSnackbar', {
						show: true,
						color: 'red darken-2',
						text: 'Terjadi Kesalahan pada sistem, hubungi administrator atau layanan mitra ' + (process.env.VUE_APP_CLIENT_INIT !== undefined) ? process.env.VUE_APP_CLIENT_INIT : 'perusahaan'
					}, { root: true });
					break;
			}
		}
	},

};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};